// extracted by mini-css-extract-plugin
export default {"tablet":"(max-width: 760px)","pageWrapper":"TestPage_pageWrapper__ZKFFv","zephrPage":"TestPage_zephrPage__0ivTY"};